// extracted by mini-css-extract-plugin
module.exports = {"scrollable_wrapper":"GraphicsSlider_scrollable_wrapper__VXNp7","scrollable_item":"GraphicsSlider_scrollable_item__Jd9Di"};